import { dateFormat, formatDate, computeHealthPriority } from '../utils.js';

class Serializer {
  normalize = data => {
    let p = data.node.assetInfo.metadata.props;
    return {
      health: data.health,
      id: data.node.nodeAddress,
      name: data.properties.locationName,
      initialDetectionTime: data.node.initialDetectionTime,
      registrationTime: data.node.registrationTime,
      registrationToken: data.node.registrationToken,
      zone: data.properties.zoneName,
      macAddress: data.properties.macAddress,
      lastSeenAt: formatDate(data.properties.lastSeenAt, dateFormat),
      accessPoint: p.symbleAccessPoint,
      healthPriority: computeHealthPriority(data.health),
      lost: p.staleHeartbeat === "true" ? 'Yes': 'No',
      batteryStatus: +p.batteryStatus
    };
  };
}

export const ReferencePointSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/status/reference/index.js